import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pack } from '../../models/Pack';
import { PackCard } from '../display';

interface PacksGridProps {
    packs: Pack[];
    error: unknown;
    isFetchingNextPage: boolean;
    lastElementRef: ((node: HTMLDivElement | null) => void) | null;
    onView: (pack: Pack) => void;
    onEdit: (pack: Pack) => void;
    onLink: (pack: Pack) => void;
    onDelete: (pack: Pack) => void;
}

const PacksGrid: React.FC<PacksGridProps> = ({
    packs,
    error,
    isFetchingNextPage,
    lastElementRef,
    onView,
    onEdit,
    onLink,
    onDelete
}) => {
    const { t } = useTranslation('packsModule');

    // No renderizar si hay error o no hay packs
    if (error || packs.length === 0) {
        return null;
    }

    return (
        <>
            {/* Grid de packs con infinite scroll */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                {packs.map((pack, index) => (
                    <div
                        key={pack.id}
                        ref={index === packs.length - 1 ? lastElementRef : null}
                    >
                        <PackCard
                            pack={pack}
                            onView={onView}
                            onEdit={onEdit}
                            onLink={onLink}
                            onDelete={onDelete}
                        />
                    </div>
                ))}
            </div>

            {/* 🔄 Indicador de carga para más elementos */}
            {isFetchingNextPage && (
                <div className="flex justify-center items-center py-6">
                    <div
                        className="text-muted-foreground text-sm"
                        data-testid="loading-more-indicator"
                    >
                        {t('loading.default')}
                    </div>
                </div>
            )}
        </>
    );
};

export default PacksGrid; 